import { Enum } from "../base/enum";

const searchOperatorEnum = new Enum(
  ["le", "lt", "ge", "gt", "eq", "ne"],
  [0, 1, 2, 3, 4, 5],
  ["<=", "<", ">=", ">", "=", "<>"]
);

export { searchOperatorEnum };
